import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=07debf85&scoped=true&"
import script from "./Viewer.vue?vue&type=script&lang=js&"
export * from "./Viewer.vue?vue&type=script&lang=js&"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=07debf85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07debf85",
  null
  
)

export default component.exports